import React from 'react';
import './footer.css';
import BlogPosts from '../blogPosts/BlogPosts';
import { FormattedMessage } from 'react-intl';
import { legalUrl } from '../../app/AppHelpers';
import { Contact } from '../contact/Contact';

export const Footer = () => {
  let legalUrlPrefix = legalUrl();
  return (
    <div className='footerWrapper'>
      <div className='footerMenu'>
        <a href={legalUrlPrefix + 'Estado-de-Informacion_OPSEEKER-TECH-SL.pdf'}>Estado De Información No Financiera Opseeker Tech, S.L.</a>
        <a href={legalUrlPrefix + 'privacy-policy.html'}><FormattedMessage id="Footer.cookies" defaultMessage="cookies-policy" /></a>
        <a href={legalUrlPrefix + 'cookies-terms.html'}><FormattedMessage id="Footer.privacy" defaultMessage="privacy-policy" /></a>
        <a href={legalUrlPrefix + 'legal-advice.html'}><FormattedMessage id="Footer.legal" defaultMessage="legal-advise" /></a>
      </div>
      <div className='misc'>
        <h2>OpSeeker blog</h2>
        <BlogPosts />
      </div>
      <Contact />
    </div>
  )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/containers/footer/Footer.js